import { useCallback, useEffect, useState } from 'react'

import { getFormattedValue } from 'shared/utils/auth'

interface IUsePhoneMaskProps {
  code?: string
  mask?: string
  initialNumber?: string
  maxLength?: number
}

export const usePhoneMask = ({ code = '', mask = '', maxLength = 11, initialNumber }: IUsePhoneMaskProps) => {
  const [formattedNumber, setFormattedNumber] = useState('')
  const [clearNumber, setClearNumber] = useState<string>(code)
  const placeholder = '_'

  const withFormatValue = useCallback((value: string) => getFormattedValue(value, mask, placeholder), [mask])

  const handleChange = useCallback(
    (value: string) => {
      const onlyDigits = value.replace(/[^\d]/g, '')
      if (onlyDigits.length > maxLength) return code.concat(onlyDigits.slice(0, -1))
      setClearNumber(code.concat(onlyDigits))
      return code.concat(onlyDigits)
    },
    [code, maxLength],
  )

  const handleFormateChange = useCallback(
    (value: string) => {
      const onlyDigits = value.replace(/[^\d]/g, '')
      if (onlyDigits.length > maxLength) return withFormatValue(onlyDigits.slice(0, -1))
      const formattedInput = withFormatValue(onlyDigits)
      setFormattedNumber(formattedInput)
      return formattedInput
    },
    [withFormatValue, maxLength],
  )

  useEffect(() => {
    if (initialNumber && !code) {
      handleFormateChange(initialNumber)
      handleChange(initialNumber)
    } else if (initialNumber && code) {
      const initialWOCode = initialNumber.replace(`${code}`, '')
      handleFormateChange(initialWOCode)
      handleChange(initialWOCode)
    }
  }, [initialNumber, code])

  return { formattedNumber, handleChange, clearNumber, handleFormateChange }
}
